import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';

@Component({
  selector: 'app-change-profile-picture-dialog',
  templateUrl: './change-profile-picture-dialog.component.html',
  styleUrl: './change-profile-picture-dialog.component.css'
})
export class ChangeProfilePictureDialogComponent {
  selectedImage: string | ArrayBuffer | null = null;
  private event: Event;
  auth = new FirebaseTSAuth();
  storage = new FirebaseTSStorage();
  file : any;
  firestore = new FirebaseTSFirestore();

  constructor(private dialogRef: MatDialogRef<ChangeProfilePictureDialogComponent>, ) {}

  onFileSelected(event: any) {

    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0] ) {
       this.file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedImage = reader.result;
      };
      reader.readAsDataURL(this.file);
    }

    
    


    
  }

  getUserId(): string {
    // Remplacez cette méthode par la logique réelle pour obtenir l'ID de l'utilisateur connecté
    return this.auth.getAuth().currentUser.uid;;
  }

  onConfirm() {
    // Ici, on peut ajouter la logique pour enregistrer l'image
    const filePath = ['Users', this.getUserId, 'ProfilePicture']; // Chemin dans Firebase Storage
    const userId = this.auth.getAuth().currentUser?.uid;
    if(userId){
      const path = `Users/${userId}/profile_photo`;
      
      this.storage.upload({
        uploadName: "Upload Cover Photo",
        path: [path],
        data: {
          data: this.file,
          metadata: { contentType: this.file.type }
        },
        onComplete: (downloadUrl) => {
          console.log('Image téléchargée avec succès. URL : ', downloadUrl);
          //this.profilePhotoUrl = downloadUrl;
          this.firestore.update(
            {
              path: ["Users", userId, ],
              data: {
                profilePhotoUrl: downloadUrl
              }
            }
          );
        },
        onFail: (err) => {
          console.error('Erreur lors du téléchargement de l\'image : ', err);
        }
      });
    
      
    }
    this.dialogRef.close(this.selectedImage);
  }


  onConfirm2(): any {
    // Ici, on peut ajouter la logique pour enregistrer l'image
    const filePath = ['Users', this.getUserId, 'ProfilePicture']; // Chemin dans Firebase Storage
    const userId = this.auth.getAuth().currentUser?.uid;
    if(userId){
      const path = `Users/${userId}/profile_photo`;
      
      this.storage.upload({
        uploadName: "Upload Cover Photo",
        path: [path],
        data: {
          data: this.file,
          metadata: { contentType: this.file.type }
        },
        onComplete: (downloadUrl) => {
          console.log('Image téléchargée avec succès. URL : ', downloadUrl);
          return downloadUrl;
          //this.profilePhotoUrl = downloadUrl;
          
        },
        onFail: (err) => {
          console.error('Erreur lors du téléchargement de l\'image : ', err);
        }
      });
    
      
    }
    this.dialogRef.close(this.selectedImage);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
